import { render } from "./modal-accordion.vue?vue&type=template&id=160a1778&scoped=true&lang=pug"
import script from "./modal-accordion.vue?vue&type=script&lang=js"
export * from "./modal-accordion.vue?vue&type=script&lang=js"

import "./modal-accordion.vue?vue&type=style&index=0&id=160a1778&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-160a1778"]])

export default __exports__